import React, { useState } from 'react';
import { SiteViewBorder, SwitchContainer, ViewContainer } from './ProteinView.elements';
import SiteMapWidget from './components/SiteMapWidget/SiteMapWidget';
import SiteMachinesTableWidget from './components/SiteMachinesTableWidget/SiteMachinesTableWidget';
import styled from 'styled-components';
import { Switch, Typography } from 'components';
import { useTranslation } from 'react-i18next';
import { SiteRouteQueryParams, SiteTableType } from 'types/protein';
import { useParams } from 'react-router-dom';
import { mapBusinessUnit } from 'common/helpers/v1/machine';
import { BusinessUnit } from 'types/dsi';
import { useGetPlantByIdQueryInfo } from '../components/hooks/useGetPlantByIdQueryInfo';

export const ProteinView = (): JSX.Element => {
  const { t } = useTranslation(['mh']);

  const { plantId } = useParams<SiteRouteQueryParams>();

  const { data: accountData } = useGetPlantByIdQueryInfo({ plantId });

  const businessUnits =
    accountData && accountData.machines.map((m) => mapBusinessUnit(m.businessUnit));
  const isDSI = businessUnits && businessUnits.includes(BusinessUnit.DSI);

  const [tableType, setTableType] = useState<SiteTableType>('MACHINE');
  const changeView = () => setTableType(tableType == 'MACHINE' ? 'LINE' : 'MACHINE');

  const SwitchLabel = styled(Typography)<{ active?: boolean }>(({ theme, active }) => ({
    color: theme.colors.darkGrey,
    fontSize: '0.875rem',
    fontWeight: active ? 'bold' : 'normal'
  }));
  return (
    <ViewContainer className="protein-line-view view-container">
      <SiteViewBorder>
        <SiteMapWidget />
        
            <SwitchContainer>
              <SwitchLabel as="span" active={tableType === 'LINE'}>
                {t('line')}
              </SwitchLabel>
              <Switch checked={tableType === 'MACHINE'} onChange={changeView} />
              <SwitchLabel as="span" active={tableType === 'MACHINE'}>
                {t('machine')}
              </SwitchLabel>
            </SwitchContainer>

            <SiteMachinesTableWidget
              plantId={plantId}
              type={tableType}
            />
          
      </SiteViewBorder>
    </ViewContainer>
  );
};

export default ProteinView;
